.waitTime {
    text-align: center;

    & strong {
        color: var(--color-lobster);
    }
}
